import React, { useEffect, useState } from 'react'
import Alert from 'react-bootstrap/Alert'
import Helmet from 'react-helmet'
import { withRouter } from 'react-router-dom'

import DNPTable from '../components/DNPTable'
import AdjusterService from '../services/AdjusterService'

export default withRouter(({ history }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState('')
  const [adjusters, setAdjusters] = useState([])

  useEffect(() => {
    AdjusterService.getAll()
      .then(data => {
        setAdjusters(data)
        setIsLoading(false)
      })
      .catch(err => {
        setError(err.message)
        setIsLoading(false)
      })
  }, [])

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center mt-2">
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }

  return (
    <div className="container mt-2 pb-3">
      <Helmet title="Adjusters" />
      {!!error && (
        <Alert variant="danger" className="mb-4 pr-5 pl-5">
          <strong>Error:</strong> <pre className="mb-0">{error}</pre>
        </Alert>
      )}
      <div className="d-flex justify-content-end my-4">
        <a className="main-link" href={`/library/adjusters/add`}>
          Add Adjuster
        </a>
      </div>
      <DNPTable
        items={adjusters}
        columns={[
          {
            title: 'Name',
            getText: item => <a href={`/library/adjusters/${item.id}`}>{item.name}</a>,
          },
          { title: 'Phone', getText: item => item.phone },
          { title: 'Email', getText: item => item.email },
          {
            title: 'Client',
            getText: item => item.client || null,
          },
        ]}
        noItemsText="No adjusters have been added"
      />
    </div>
  )
})
